module.exports = __webpack_public_path__ + "img/Midlothian.9fc10c24.png";